export default "__VITE_ASSET__c28b894b__"